import Vue from 'vue'
import { JSEncrypt } from 'jsencrypt'

const publicKey =
  'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKE0ih1QA8wc2mfYMelG1AK9md/SR3jC14wyO3DW2BVcJXArbAx1IAb+w+kD4Vm3ZbD6tuEfPXVHAx7YJqV606kCAwEAAQ==' //
class JSEncryptUtil {
  init() {
    const encryptor = new JSEncrypt()
    encryptor.setPublicKey(publicKey) // 设置公钥
    return encryptor
  }
}
export default new JSEncryptUtil()



// WEBPACK FOOTER //
// ./src/common/js/jSEncryptUtil.js